import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ApiCredential, ApiCredentialCreate, ApiCredentialFilter } from '../data/apiCredential';

export function createApiCredentialService(client: AxiosInstance) {
  return createCrudService<ApiCredential, ApiCredentialCreate, ApiCredentialFilter>(
    client,
    '/integration/ApiCredential',
    'id',
  );
}

export type ApiCredentialService = CrudService<ApiCredential, ApiCredentialCreate, ApiCredentialFilter>;
